import "vue-tsx-support/enable-check"
import {VNode} from 'vue'
import * as tsx from "vue-tsx-support";
import './cellOperate.less'
import Icon from "../../types/iview/Icon";
import { CommonUtil } from 'src/util/commonUtil';

type Fn = (params: any)=> boolean
export interface CellOperateItemProps {
	text: string

	click? (data): void

	hide?: boolean|Fn
	disabled?: boolean|Fn
	loading?: boolean
}

interface CellOperateItemStates {
	dataSource: Array<CellOperateItemProps>
}

const CellOperate = tsx.componentFactory.create({
	data (): CellOperateItemStates {
		return {
			dataSource: []
		}

	},
	methods: {
		async click(item, params) {
			if (this.judgeDisable(item, params)) {
				return
			}
			if (item.loading) {
				return
			}
			let res = item.click(params)
			if (res instanceof Promise) {
				item.loading = true
				this.$forceUpdate()
				await res
				item.loading = false
				this.$forceUpdate()
			}
		},
		judgeDisable (item: CellOperateItemProps, params) {

			// 如果传入判断disable函数  按函数结果返回
			if (CommonUtil.isFunction(item.disabled)) {
				return item.disabled(params)
			} else {
				return item.disabled
			}
		},
		judgeHide (item: CellOperateItemProps, params) {
			// 如果传入判断disable函数  按函数结果返回
			if (CommonUtil.isFunction(item.hide)) {
				return item.hide(params)
			} else {
				return item.hide
			}
		},
		judgeNormal (item) {
			//	是否只显示文本
			// 如果是  需手动在代码里写click的空处理
			return item.normal
		},
		itemName (item, params) {
			//	展示动态Name
			let res
			let name
			name = CommonUtil.isFunction(item.name) ? item.name(params) : item.name
			res = item.showFiledName ? params.value : name
			return res
		}
	},
	created () {
		let cellRendererFrameworkOpt: Array<CellOperateItemProps> = (this.params.colDef.cellRendererFrameworkOpt) as Array<CellOperateItemProps>
		this.dataSource = cellRendererFrameworkOpt
	},
	render (h): VNode {

		return (
			<div class="wqms-cell-operate">
				{
					this.dataSource.map((item) => {
						return (
							!this.judgeHide(item, this.params) ?
								<span
									onClick={()=>{this.click(item, this.params)}}
									class={{
										'wqms-cell-operate-item': true,
										'wqms-cell-operate-item-disabled': this.judgeDisable(item, this.params)
									}}>
									{item.text}
									<Icon type="ios-loading" class="ivu-load-loop wms-ml2" v-show={item.loading}></Icon>
									</span> : ''
						)
					})
				}
			</div>
		)
	}
})
export default CellOperate
